<template>
  <v-flex>
    <v-autocomplete
      v-model="inputValue"
      :name="schema.fullKey"
      :disabled="schema.disabled"
      :required="schema.required"
      :rules="rules()"
      item-value="value"
      item-text="label"
      :items="schema.items"
      :label="schema.label"
      persistent-hint
      :readonly="schema.readonly"
      @input="emitInput($event)"
    >
      <v-tooltip
        v-if="schema.description && schema.description.length > 0"
        slot="append"
        left
      >
        <v-icon slot="activator">info</v-icon>
        <div class="vjsf-tooltip" v-html="schema.description"></div>
      </v-tooltip>
    </v-autocomplete>
  </v-flex>
</template>

<script>
import { Utils } from '../Utils'
var utils = new Utils()

export default {
  name: 'RDSelectWidget',
  props: {
    schema: {
      type: Object,
      required: true
    },
    value: {
      type: [Object, String, Number],
      default: null
    }
  },
  data() {
    return {
      inputValue: this.value || null
    }
  },
  mounted() {},
  created: function() {
    if (this.schema.url != undefined) {
      this.$emit('getItems', this.schema.url, this.schema.fullKey)
    }
    if (this.schema.hide) {
      this.$emit('hide', this.schema.hide, this.inputValue)
    }
    if (this.schema.show) {
      this.$emit('show', this.schema.show, this.inputValue)
    }
  },

  methods: {
    emitInput: function(value) {
      if (this.schema.transmit != undefined) {
        this.$emit(
          'transmit',
          this.schema.transmit,
          this.schema.items[this.inputValue]
        ) //this.inputValue for id only
      }
      this.$emit('inputChange', value)
      this.$emit('input', value)
      if (this.schema.hide != null) {
        this.$emit('hide', this.schema.hide, value)
      }
      if (this.schema.show != null) {
        this.$emit('show', this.schema.show, value)
      }
    },
    rules() {
      if (this.schema.rules === undefined || this.schema.rules === null) return
      var rules = []
      if (this.schema.rules.required === true)
        rules = rules.concat(utils.getRequiredRules())
      return rules
    }
  }
}
</script>
